<!--
  ~ Copyright (c) Worldline 2022.
  -->

<!DOCTYPE html>

<main role="main">
    <h2 id="title-agreements">
        {{ 'documents.title' | signatureAction: currentSignature?.action | translate:{NB_DOCUMENTS: signatures.length} }}
        <small> <span *ngIf="signerName()">-
            {{signerName()}}</span>
        </small>
    </h2>
    <section class="infoBox ng-scope">
        <p id="nb-documents" *ngIf="containsTrueSignatures">
            {{ 'documents.infoBox' | signatureAction: 'SIGNATURE' | translate:{NB_DOCUMENTS: trueSignatures.length} }}
        <ul *ngIf="containsTrueSignatures"
            [ngClass]="{'noBullet' : trueSignatures.length == 1}">
            <li *ngFor="let signature of trueSignatures; let i = index" id="doc-to-process-{{i}}">
                {{signature.documentDto?.documentName}} : <strong
                    *ngIf="signatureIsDone(signature)">{{
                'documents.document.agreed' | signatureAction: 'SIGNATURE'
                    | translate }}</strong> <strong
                    *ngIf="!signatureIsDone(signature)">{{
                'documents.document.not.agreed' | signatureAction:
                    'SIGNATURE' | translate }}</strong>
            </li>
        </ul>
    </section>
    <section>
        <form id="form-consents-smartphone" [formGroup]="formConsentsValidation" class="content" name="form.consents.smartphone"
              novalidate>
            <div *ngIf="consents">
                <p>
                    <small id="mandatory-consents">{{ 'documents.consents.mandatory' | translate }}
                    </small>
                </p>
                <fieldset class="k-check" *ngFor="let consent of consents">
                    <legend id="consent-title">{{consent.title}}</legend>
                    <ul>
                        <li *ngFor="let consentText of consent.consentTextDtoList">

                            <input
                                    type="checkbox"
                                    [formControlName]="'consent-'+consent.rank+'_text-'+consentText.status.rank"
                                    [id]="'consent-'+consent.rank+'_text-'+consentText.status.rank"
                                    [required]="consentText.mandatory"
                                    [(ngModel)]="consentText.status.ticked"
                                    [checked]="consentText.status.ticked"
                                    (change)="formReset()"
                                    [disabled]="alreadyConsented || (controlDocumentCompleteReading && !documentFullyRead)"/>
                            <label [for]="'consent-'+consent.rank+'_text-'+consentText.status.rank">
                                <span [id]="'label-consent-'+consent.rank+'_text-'+consentText.status.rank" [innerHTML]="consentText.text"></span>
                            </label>
                        </li>
                    </ul>
                </fieldset>
            </div>
        </form>
        <form id="form_handsign" (submit)="submitSignature()" novalidate
              name="form.handsign" autocomplete="off">
            <h3>{{ 'signature.title' | translate}}</h3>

            <br/>

            <p class="error-form" *ngIf="signaturePad && signaturePad.isEmpty() && submitted">{{
                "signature.form.error.required" | translate }}</p>

            <wl-hand-sign #signature [options]="handSignOptions"></wl-hand-sign>
            <br/>
            <p class="k-buttons-bar">
                <input type="button" *ngIf="onHoldAvailability && !onHoldLimitReached" value="{{ 'confirmCancellation.hold' | translate }}"
                       class="k-button k-button-primary"
                       (click)="hold()"/>
                <input type="submit" id="hand-sign-button"
                       value="{{ 'documents.button' | signatureAction: currentSignature?.action | translate }}"
                       class="k-button ic-check submitConsent"
                       [attr.uib-tooltip]="'tooltip.agreements.sign' | translate" [disabled]="signaturePad?.isEmpty() || isSubmitButtonDisabled()"
                       [attr.uib-tooltip-enable]="isSubmitButtonDisabled()"
                />
            </p>
        </form>
    </section>
    <span *ngIf="errorMsg">{{ errorMsg | translate}}</span>
</main>
<div id="mobile_landscape" #mobile_landscape class="mobile_landscape">
    <div class="mobile_landscape_box">
        <li id="mobile_landscape_pic">...</li>
        <span>{{ 'orientation.change' | translate }}</span>
    </div>
</div>










